





























































import { Component, Prop } from 'vue-property-decorator';
import Modal from './Modal.vue';
import CommonVue from '../models/commonVue';
import ApiList from '@/api/list';
import Module from '@/api/module';
import Dimmer from '@/components/Dimmer.vue';
import DropDownEntity from '@/components/DropDownEntity.vue';
import { VueGoodTable } from 'vue-good-table';
import papaparse from 'papaparse';
import { isEmpty, isNil, uniq } from 'lodash';
import { importExercise, importExerciseContent } from '@/util/import';
import Lesson from '@/api/lesson';
import LockManager from '@/models/lock';
import { lock } from '@/util/common/util';
import Exercise from '@/api/exercise';

@Component({
  components: {
    modal: Modal,
    'drop-down-entity': DropDownEntity,
    'data-table': VueGoodTable,
    dimmer: Dimmer
  }
})
export default class MassImport extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;

  public rows: { [key: string]: string }[] = [];
  public columns = [
    {
      label: 'Module Id',
      field: 'module_id',
      type: 'string'
    },
    {
      label: 'Lesson ID',
      field: 'lesson_id',
      type: 'string'
    },
    {
      label: 'Lesson Name',
      field: 'lesson_name',
      type: 'string'
    },
    {
      label: 'Game Type',
      field: 'game_type',
      type: 'string'
    },
    {
      label: 'Exercise Id',
      field: 'exercise_id',
      type: 'string'
    },
    {
      label: 'Status',
      field: 'status',
      type: 'string'
    }
  ];

  public moduleList: ApiList<Module> = null;
  public showModal: boolean = false;
  public isUploadButtonDisabled: boolean = true;

  public async show() {
    this.showModal = true;
  }

  public async openFileDialog() {
    const link = document.getElementById('file-input');
    link.click();
  }

  public async parseCSVData(file: File) {
    const csv = await file.text();
    const result = papaparse.parse<{ [key: string]: string }>(csv, {
      header: true,
      skipEmptyLines: true
    });

    console.log(result);
    this.rows = result.data.map((item) => {
      return {
        ...item,
        status: 'None'
      };
    });
  }

  public async onFileChange(files: FileList): Promise<void> {
    const file = files.item(0);
    if (!file) {
      return;
    }

    this.parseCSVData(file);
    const form = document.getElementById('file-form') as any;
    form.reset();
    this.isUploadButtonDisabled = false;
  }

  private async saveExercise(data: { [key: string]: string }) {
    if (
      isNil(this.moduleId) ||
      data['module_id'] !== this.moduleId.toString()
    ) {
      data.status = 'Error';
    }

    try {
      data.status = isEmpty(data['exercise_id'])
        ? 'Creating Exercise'
        : 'Updating Exercise';
      const exercise = await importExercise(data);
      data.exercise_id = exercise.id;
      return exercise;
    } catch (err) {
      console.log(err);
      data.status = `Error! ${err.message}`;
      return null;
    }
  }

  public async upload() {
    const lessonIds = uniq(this.rows.map((item) => item['lesson_id']));
    const locks: LockManager[] = [];

    for (let i = 0; i < lessonIds.length; i++) {
      const lessonLock = await lock(Lesson.SLUG, Number.parseInt(lessonIds[i]));
      locks.push(lessonLock);
    }

    const exercisesToUpload: {
      exercise: Exercise;
      data: { [key: string]: string };
    }[] = [];

    this.isUploadButtonDisabled = true;

    for (const item of this.rows) {
      const exercise = await this.saveExercise(item);
      if (!isNil(exercise)) {
        exercisesToUpload.push({ exercise, data: item });
      }
    }

    for (let i = 0; i < locks.length; i++) {
      await locks[i].releaseLock();
    }

    const promises = exercisesToUpload.map(async (item) => {
      try {
        item.data['status'] = 'Importing Content';
        await importExerciseContent(item.exercise, item.data);
        item.data['status'] = 'Done';
      } catch (err) {
        console.log(item.exercise.id + ' ' + err.message);
        item.data['status'] = 'Error';
      }
    });

    await Promise.all(promises);
  }
}
